import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_brkasb91: FaireBrandEntity = {
  token: "b_brkasb91",
  type: "brand",
  name: "HarperCollins",
  avatarUrl:
    "https://cdn.faire.com/fastly/f13bdb21e86a21b52d30e53bc3fefd6898cb58bedf9b7c05a837189727730702.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f2b39b6eaa4d5d051402c1eae06ed42b44dad9727588ac515b9652ed8e10619d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f13bdb21e86a21b52d30e53bc3fefd6898cb58bedf9b7c05a837189727730702.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f2b39b6eaa4d5d051402c1eae06ed42b44dad9727588ac515b9652ed8e10619d.png",
  location: "NEW YORK, NY, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 214,
  isTopShop: true,
  isInsider: true,
  description:
    "HarperCollins Publishers has been entertaining, educating, and inspiring generations of readers for more than 200 years. From its humble beginnings as a family-run print shop, HarperCollins is today the second-largest consumer book publisher in the world. We seek to publish books that present a diversity of voices and speaks to the global community.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:27.813Z",
    importedBy: "entity-db-cli",
  },
};
